<template>
  <div class="flex items-center ml-2">
    <aha-status-badge
      v-if="!isFetchingMisspells"
      :count="misspellCount"
      :overflowCount="9"
      class="mr-2"
    />
    <aha-spinner v-if="isFetchingMisspells" class="mr-2" />
    <span class="text-pink-50 font-bold bg-pink-10 rounded py-1 px-2 text-sm">Beta</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('spellchecker', ['misspells', 'isFetchingMisspells']),

    misspellCount() {
      return this.misspells?.length || 0
    },
  },
}
</script>
